export interface AboutBenefitModel {
  ref: string;
  src: any;
  title: string;
  description: string;
}

export const aboutBenefits: AboutBenefitModel[] = [
  {
    ref: 'inspiration',
    src: () => require('@shared/assets/inspiration_icon.svg'),
    title: 'Inspiration',
    description: 'We strive to inspire young minds. Our relationships with our customers inspire us.',
  },
  {
    ref: 'integrity',
    src: () => require('@shared/assets/integrity_icon.svg'),
    title: 'Integrity',
    description: 'We are motivated by and aspire to positive thinking. Our approach to our work is defined by a dedication to integrity.',
  },
  {
    ref: 'collaboration',
    src: () => require('@shared/assets/collaboration_icon.svg'),
    title: 'Collaboration',
    description: 'Our success is derived from the diversity of perspectives and opinions that informs it. We seek to cultivate a collaborative environment.',
  },
  {
    ref: 'innovation',
    src: () => require('@shared/assets/innovation_icon.svg'),
    title: 'Innovation',
    description: 'We are passionate about what we do. We are committed to innovative solutions and innovative thought leadership.',
  },
  {
    ref: 'simplicity',
    src: () => require('@shared/assets/simplicity_icon.svg'),
    title: 'Simplicity',
    description: 'Our solutions are easy to use. Our ideals are simple to understand. Our approach to our work is straightforward.',
  },
];
